import { useTranslation } from 'react-i18next'
import CheckIcon from '@mui/icons-material/Check'

import Button, { ButtonColor, ButtonVariant } from '../../../Button'
import {
  Modal,
  ModalDescription,
  ModalHeader,
  ModalTitle,
  ModalFooter,
} from '../../../Modal'
import { useLanguage } from '../../../../modules/i18n'
import { type Move } from '../../../../modules/moves'
import FrenchContent from '../../../../pages/bookingTerms/BookingTerms.fr'
import EnglishContent from '../../../../pages/bookingTerms/BookingTerms.en'
import LongDistanceFrenchContent from '../../../../pages/bookingTermsLongDistance/BookingTermsLongDistance.fr'
import LongDistanceEnglishContent from '../../../../pages/bookingTermsLongDistance/BookingTermsLongDistance.en'

type BookingTermsModalProps = {
  open: boolean
  move: Move
  onClose: () => void
  onAccept: () => void
}

const BookingTermsModal: React.FC<BookingTermsModalProps> = ({
  open,
  move,
  onClose,
  onAccept,
}) => {
  const { t } = useTranslation()
  const language = useLanguage()
  const { isLongDistance } = move.state

  const renderTitle = () => {
    if (isLongDistance) {
      return t('pages.bookingTermsLongDistance.title')
    }
    return t('pages.bookingTerms.title')
  }

  const renderContent = () => {
    if (isLongDistance) {
      return language === 'fr' ? <LongDistanceFrenchContent /> : <LongDistanceEnglishContent />
    }
    return language === 'fr' ? <FrenchContent /> : <EnglishContent />
  }

  return (
    <Modal
      open={open}
      onClose={() => { onClose() }}
      style={{ maxWidth: 800 }}
    >
      <ModalHeader>
        <ModalTitle>
          { renderTitle() }
        </ModalTitle>
      </ModalHeader>
      <ModalDescription className="max-h-[calc(100vh-250px)]">
        <div className="prose mb-8 max-w-none font-body prose-headings:font-body2">
          { renderContent() }
        </div>
      </ModalDescription>
      <ModalFooter>
        <Button
          variant={ButtonVariant.Outlined}
          color={ButtonColor.Primary}
          onClick={onAccept}
          startIcon={<CheckIcon className="-mr-1" />}
        >
          { t('actions.accept') }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default BookingTermsModal
